/* SLIDE 4 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { changePassword } from "features/auth/usecases/AuthUsecases";
import { useSelector } from "react-redux";

const ResetPasswordPage = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangePassword = async () => {
    const { password, confirmPassword } = formData;
  
    if (password !== confirmPassword) {
      alert("Wrong password !");
      return;
    }

    const result = await changePassword({
      id: user.userId,
      password: password,
    });
  
    if (result) {
      alert("Success!");
      navigate("/menu_manager", { replace: true });
    } else {
      alert("Fail!");
    }
  };

  return (
    <div className="password-confirm-container mn-password-confirm-container">
      <div className="form-wrapper">
        <div className="form-box">
          <form onSubmit={handleSubmit(handleChangePassword)} className="password-form">
            <div className="form-header">
              <h3 className="korean">최초 로그인 시 비밀번호 변경</h3>
              <p className="korean">
                소중한 개인정보보호를 위해 비밀번호를 변경해주시기 바랍니다. (영문, 숫자를 혼합하여 6-10자 이내)
              </p>
            </div>
            <div className="form-group">
              <label className="korean">변경할 비밀번호 입력</label>
              <div className="input-container">
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="변경할 비밀번호 입력"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="korean">변경할 비밀번호 확인</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="form-input"
                placeholder="변경할 비밀번호 확인"
              />
            </div>

            <div className="button-container">
              <button type="submit" className="submit-button">
                확인
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
